/* eslint-disable */
import $ from 'jquery';
import React from 'react';
import { connect } from 'react-redux';
import agent from '../../actions/index';
import RegisterMenu from './RegisterMenu';
import CommonClass from '../../js/common';
import {
    REGISTER_PAGE_UNLOADED,
    UPDATE_FIELD_AUTH,
    USER_REGISTER,
    USER_INVITE
} from '../../constants/actionTypes';

const mapStateToProps = state => ({
    ...state.home,
    appName: state.common.appName,
    token: state.common.token
});

const mapDispatchToProps = dispatch => ({
    onChangeFirstName: value =>
        dispatch({ type: UPDATE_FIELD_AUTH, key: 'FirstName', value }),
    onChangeLastName: value =>
        dispatch({ type: UPDATE_FIELD_AUTH, key: 'LastName', value }),
    onChangeEmail: value =>
        dispatch({ type: UPDATE_FIELD_AUTH, key: 'email', value }),
    onSubmit: (FirstName, LastName, email, UserType) =>
        dispatch({ type: USER_INVITE, payload: agent.Auth.invite(FirstName, LastName, email, UserType) }),
    onUnload: () =>
        dispatch({ type: REGISTER_PAGE_UNLOADED })
});

class Invite extends React.Component {
    constructor() {
        super();

        this.state={
            activeSwimmerRadioBtnValue:null
        }

        this.handleSwimmerRadioBtnClick = this.handleSwimmerRadioBtnClick.bind(this);
        this.loader = null;
        this.changeFirstName = ev => this.props.onChangeFirstName(ev.target.value);
        this.changeLastName = ev => this.props.onChangeLastName(ev.target.value);
        this.changeEmail = ev => this.props.onChangeEmail(ev.target.value);
        this.submitForm = (FirstName, LastName, email, UserType) => ev => {
            ev.preventDefault();
            this.loader = (
                <div id="loader-wrapper">
			<div id="loader"></div>

			<div class="loader-section section-left"></div>
			<div class="loader-section section-right"></div>

		</div>
            );
            if (FirstName == "" || FirstName == undefined) {
                $("#message").html("Please enter first name");
                $("#message").show();
            }
            else if (LastName == "" || LastName == undefined) {
                $("#message").html("Please enter last name");
                $("#message").show();
            }
            else if (email == "" || email == undefined) {
                $("#message").html("Please enter email");
                $("#message").show();
            } else if (UserType == "" || UserType == undefined) {
                $("#message").html("Please select a category");
                $("#message").show();
            }
            else {
                if (this.validateEmail(email)) {
                    $("#message").html("");
                    $("#message").hide();
                    this.props.onSubmit(FirstName, LastName, email, UserType);
                }
                else {
                    $("#message").html("Please enter valid email");
                    $("#message").show();
                }
            }
        }
    }

    validateEmail(email_id) {

        var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;

        if (filter.test(email_id)) {
            return true;
        }
        else {
            return false;
        }
    }

    handleSwimmerRadioBtnClick(activeValue){
        this.setState({
            activeSwimmerRadioBtnValue: activeValue
        })}
        
    componentWillMount() {

    }

    componentDidMount() {


        var CONTAINER_ORIGINAL_WIDTH = $('#MainContainer').css('width');
        var CONTAINER_ORIGINAL_HEIGHT = $('#MainContainer').css('height');

        var CONTAINER1_ORIGINAL_WIDTH = $(window).width();
        var CONTAINER1_ORIGINAL_HEIGHT = $(window).height();

        var mobileHightAdj = 50;
        var mobileWidthAdj = 50;

        var resizePadding = 1;
        var mousehover = 0;

        var isPortrait = false;
        var isMobile = false;

        if (window.matchMedia("(orientation: portrait)").matches) {
            // you're in PORTRAIT mode
            isPortrait = true;
        }

        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
            .test(navigator.userAgent)) {
            mousehover = 1;
            isMobile = true;
        } else {
            if (isPortrait == true) {
                $("#portrait-blocker").hide();
            }
        }

        $("#MainContainer").css('width', CONTAINER_ORIGINAL_WIDTH);
        $("#MainContainer").css('height', CONTAINER_ORIGINAL_HEIGHT);

        var screen = {
            left: 0,
            top: 0,
            width: 0,
            height: 0
        };

        screen.width = window.innerWidth;
        screen.height = window.innerHeight;
        var scaleTo = 1;

        screenresize(true);;

        $(window).resize(function () {
            screenresize(true);;
        });

        function screenresize(isonload) {
            var width = $(window).width();
            var height = $(window).height();

            var maxWidth = window.screen.width;
            var maxHeight = window.screen.height;

            if (resizePadding == 1) {
                maxHeight = maxHeight + (mobileHightAdj);
                maxWidth = maxWidth + (mobileWidthAdj);
            }

            var scaleTo;

            if (width >= maxWidth && height >= maxHeight) {
                scaleTo = 1;
            } else {
                scaleTo = Math.min(width / maxWidth, height / maxHeight);
            }

           // $('#MainContainer').css({ "transform": "scale(" + scaleTo + ")" });

            var containerLeft = 0;
            if ($(window).width() < parseInt(CONTAINER_ORIGINAL_WIDTH.replace("px", ""))) {
                containerLeft = - (parseInt(CONTAINER_ORIGINAL_WIDTH.replace("px", "")) - $(window).width()) / 2;
            }
            $('#MainContainer').css('left', containerLeft);

            var containerTop = (height - (maxHeight * scaleTo)) / 2;

            if ($('.content-container').hasClass('active') == true) {
                $("#MainContainer").css('width', CONTAINER1_ORIGINAL_WIDTH);
                $("#MainContainer").css('height', CONTAINER1_ORIGINAL_HEIGHT);
            }
        }
    }
    componentWillUnmount() {
        this.props.onUnload();
    }
    render() {
        const FirstName = this.props.FirstName;
        const LastName = this.props.LastName;
        const email = this.props.email;
        if (this.props.tags != undefined) {
                this.loader = null;
                $('#register,#registerBtn').show();
                $("#messageBack").hide();
                $("#message").show();
                $('#email').show();
                $("#messageBack").html("You’re all set !!!");
                $('#messageBack').show();
                $('#card').addClass('flipped')
            }
           
        return (
            <div className="content-resize-container" id="MainContainer">
                <RegisterMenu />

                <div className="main" >
                    <div className="main-content" id="registerNow">


                        <div className="apData regWrap lv-container">
                            <h2 className="back-btn-head" onClick={() => this.props.history.goBack()} ><img className="back-btn" src={CommonClass.cdn_url + "images/back-btn.svg"} /><span className="invite-back-btn">Back</span></h2>
                            <h2><img className="textSvg" src={CommonClass.cdn_url + "images/lanevision.svg"} /></h2>

                            {/* <p className="p20" style={(this.props.tags !== undefined && this.props.tags.code !== "USR-1003") ? {display: 'none'} : null}>Thank you! We are excited to have you onboard!<br />
                                Lanevision is currently available on an invite only basis, 
                             <br />please leave your details below to receive an invite!
                                
                            </p> */}
                            
                            <p className="p20 lv-txt" style={(this.props.tags !== undefined && this.props.tags.code !== "USR-1003") ? {display: 'none'} : null}>Immerse yourself in the future of swim analytics<br /> by downloading the Lanevision app today and <br />elevate your swimming adventures like never before!</p>
                            
                            <div id="card">
                                <div className='lanevision-img'>
                                    <a href="https://apps.apple.com/in/app/lanevision/id1469038922" target='_blank'>
                                      <img className='lv-img' src={CommonClass.cdn_url + "images/app-store.svg"} alt='app store' title="available on app store" />
                                    </a>
                                        
                                    <a href="https://play.google.com/store/apps/details?id=com.lane.vision" target='_blank'>
                                      <img className='lv-img' src={CommonClass.cdn_url + "images/google-play.svg"} alt='google play' title='available on google play store' />
                                    </a>                                    
                                </div>
                            </div>
                            {/* <div id="card">
                                <div className="face front">
                                    <div className="well well-sm inner">
                                        <form id="register" action="#" method="post">
                                            <input id="FirstName" type="text" name="FirstName" maxLength={40} placeholder="First name" required="" value={this.props.FirstName}
                                                onChange={this.changeFirstName} />
                                            <input id="LastName" type="text" name="LastName" maxLength={40} placeholder="Last name" required="" value={this.props.LastName}
                                                onChange={this.changeLastName} />
                                            <input id="email" type="email" name="Email" placeholder="Email ID" required="" value={this.props.email}
                                                onChange={this.changeEmail} />
                                        </form>

                                        <div className="invite-radio-wrapper">
                                            <div className="single-col">
                                                <div className="styled-input-container styled-input--square">
                                                    <div className="styled-input-single">
                                                        <span className="left-trip"></span>
                                                        <span className="right-trip"></span>
                                                        <div onClick={()=>this.handleSwimmerRadioBtnClick('Swimmer')}>
                                                        <input id="rbtnSwimmer" type="radio" name="Swimmer"  value="swimmer" checked={this.state.activeSwimmerRadioBtnValue ==='Swimmer'?true: false} />
                                                        <label htmlFor="rbtnSwimmer">Swimmer</label>
                                                        </div>
                                                        
                                                    </div>
                                                    <div className="styled-input-single">
                                                        <span className="left-trip"></span>
                                                        <span className="right-trip"></span>
                                                        <div onClick={()=>this.handleSwimmerRadioBtnClick('Coach')} >
                                                        <input id="rbtnCoach" type="radio" name="Swimmer" value="coach" checked={this.state.activeSwimmerRadioBtnValue === 'Coach' ? true : false}/>
                                                            <label htmlFor="rbtnCoach">Coach</label>
                                                        </div>
                                                       
                                                    </div>
                                                    <div className="styled-input-single">
                                                        <span className="left-trip"></span>
                                                        <span className="right-trip"></span>
                                                        <div onClick={()=>this.handleSwimmerRadioBtnClick('SwimParent')}>
                                                        <input id="rbtnSwimParent" type="radio" name="Swimmer" value="swim parent"  checked={this.state.activeSwimmerRadioBtnValue === 'SwimParent' ? true : false}/>
                                                            <label htmlFor="rbtnSwimParent">Swim Parent</label>
                                                        </div>
                                                        
                                                    </div>


                                                </div>
                                            </div>


                                           


                                        </div>




                                        <div id="message" className="message" style={{ 'width': '100%', 'textAlign': 'center', 'marginTop': '15px', 'color': '#f05127' }}></div>
                                        <div id="registerBtn" className="arwAnimWrap">
                                            <a href="#" className="calltoAction">
                                                <span className="leftArw animArrows">
                                                    <svg version="1.1" id="leftArrow" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 10" enableBackground="new 0 0 24 10">
                                                        <g className="leftArwPath">
                                                            <path id="leftR3" fillRule="evenodd" clipRule="evenodd" fill="#777" d="M23.499,5l-7.665-4.499v8.998L23.499,5" />
                                                            <path id="leftR2" fillRule="evenodd" clipRule="evenodd" fill="#777" d="M15.834,5L8.169,0.501v8.998L15.834,5" />
                                                            <path id="leftR1" fillRule="evenodd" clipRule="evenodd" fill="#777" d="M8.166,5L0.501,0.501v8.998L8.166,5" />
                                                        </g>
                                                    </svg>
                                                </span>
                                                <span onClick={this.submitForm(FirstName, LastName, email, this.state.activeSwimmerRadioBtnValue)}>send me an invite</span>
                                                <span className="rightArw animArrows">
                                                    <svg version="1.1" id="rightArrow" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 10" enableBackground="new 0 0 24 10">
                                                        <g className="rightArwPath">
                                                            <path id="rightL1" fillRule="evenodd" clipRule="evenodd" fill="#777" d="M0.501,5l7.665,4.499V0.501L0.501,5" />
                                                            <path id="rightL2" fillRule="evenodd" clipRule="evenodd" fill="#777" d="M8.166,5l7.665,4.499V0.501L8.166,5" />
                                                            <path id="rightL3" fillRule="evenodd" clipRule="evenodd" fill="#777" d="M15.834,5l7.665,4.499V0.501L15.834,5" />
                                                        </g>
                                                    </svg>
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                {this.loader}
                                <div className="face back">
                                    <div className="well well-sm inner">
                                        <div id="messageBack" className="back p20" style={{ 'width': '100%', 'textAlign': 'center', 'marginTop': '15px', 'color': '#f05127' }}></div>
                                    </div>
                                </div>
                            </div> */}

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Invite);



// WEBPACK FOOTER //
// src/components/Home/Invite.js